module.exports = __webpack_public_path__ + "static/media/ok.462118ca.svg";